import { useMemo } from 'react';
import { useShowResults } from '~/hooks/instantSearch/useShowResults';
import { useCategoryResults } from '~/hooks/useCategoryResults';
import { InstantCategoryList } from './InstantCategoryList';

export const InstantCategories = () => {
    const { categoryResults } = useCategoryResults();
    const { showCategoryResults } = useShowResults();

    const categoriesToShow = useMemo(() => {
        return categoryResults.filter(
            (categoryResult) => categoryResult.result.totalRecords > 0 || categoryResult.state.setting.showZeroResults
        );
    }, [categoryResults]);

    if (!categoryResults || !showCategoryResults) {
        return null;
    }

    return (
        <>
            {categoriesToShow.map((categoryResult) => (
                <InstantCategoryList key={categoryResult.title} categoryResult={categoryResult} />
            ))}
        </>
    );
};
